export { default as HeroSection } from './HeroSection';
export { default as CategoriesSection } from './CategoriesSection';
export { default as ProductsSection } from './ProductsSection';
export { default as GlutenFreeSection } from './GlutenFreeSection';
export { default as NewsletterSection } from './NewsletterSection';
export { default as RecipeSection } from './RecipeSection';
export { default as InfoCardsSection } from './InfoCardsSection';
export { default as AboutSection } from './AboutSection';
export { default as AboutSectionCategories } from './AboutSectionCategories';
export { default as FAQSection } from './FAQSection';
export { default as FAQSectionCategories } from './FAQSectionCategories';
export { default as OtherProductsSection } from './OtherProductsSection';
export { default as RelatedProductsSection } from './RelatedProductsSection';

// Product-specific components
export { default as ProductsFilterBar } from './ProductsFilterBar';
export { default as ProductsGrid } from './ProductsGrid';
export { default as ProductsPageContent } from './ProductsPageContent';

// Account page
export { default as AccountSectionWrapper } from './AccountSectionWrapper';
